// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__lsBPH","empty":"ModalGraph_empty__6-aOf"};